import { createBrowserHistory } from 'history';
import { staticPageUrls, giftCardMallAmounts } from './consts';

export const isValidEmail = (email) => {
  if (email) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.trim());
  }
  return false;
};

export const messageKeyDown = (event) => {
  // Prevent enter and blackslash key
  if (event.keyCode === 13 || event.keyCode === 220) {
    event.preventDefault();
  }
};

export const redirectToLanding = () => {
  window.location.href = staticPageUrls.landing.url;
};

export const getUrlParam = (key) => {
  const searchParams = typeof window !== 'undefined' ? window.location?.search : '';
  const urlParams = new URLSearchParams(searchParams);
  return urlParams.get(key);
};

export const navigateToNextGiftCardPath = (pathObj, refresh = false) => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const urlObj = new URL(window.location.href);
    const { pathname, searchParams } = urlObj;
    const newParams = new URLSearchParams(searchParams);
    const { configurationId, urlParams } = pathObj;
    let nextPath = pathname;
    let search = searchParams.toString();

    if (configurationId) {
      nextPath = nextPath.substring(0, nextPath.lastIndexOf('/') + 1) + configurationId;
    }
    if (urlParams && urlParams.length > 0) {
      urlParams.forEach((param) => {
        if (param?.newValue) {
          newParams.set(param.key, param.newValue.toString());
        } else {
          newParams.delete(param.key);
        }
      });
      search = newParams.toString();
    }
    const url = `${window.location.origin}${nextPath}?${search}`;
    const history = createBrowserHistory();
    history.push(url);
    if (refresh) {
      history.go();
    }
  }
};

export const getPriceDenomination = (min = 5, max = 2000) => {
  if (min && min === max) {
    return [min];
  }
  return giftCardMallAmounts.filter((giftCardAmount) => {
    return giftCardAmount >= min && giftCardAmount <= max;
  });
};

export const getCookieValue = (cookieName) => {
  if (typeof document === 'undefined') {
    return null;
  }
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookie.split(';');
  let result = null;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      result = cookie.substring(name.length, cookie.length);
      break;
    }
  }

  if (result !== undefined && (result === 'true' || result === 'false')) {
    result = JSON.parse(result);
  }

  return result;
};
